export const SUPPORTED_LOCALES = ['en', 'ja'];
export const DEFAULT_LOCALE = SUPPORTED_LOCALES[1];
